import CustomReport from './CustomReport.container';

export default CustomReport;
export { default as CustomReportParam } from './CustomReportParam.container';
